import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { API_ROOT } from '@Helpers/apiConfig';
import { createPacerApi } from '@Helpers/pacerApi';
import { saveFile } from '@Helpers/saveFile';

// ---- Mutations: File Download ----
// Downloading needs the raw response (headers drive the file name), so the
// mutation saves the blob via file-saver instead of returning JSON.

const downloadFile = async (fileName: string): Promise<void> => {
    const response = await createPacerApi().get(`${API_ROOT}files/download?f=${encodeURIComponent(fileName)}`);
    await saveFile(response);
};

const downloadFileBlob = async (fileName: string): Promise<Blob> => {
    const response = await createPacerApi().get(`${API_ROOT}files/download?f=${encodeURIComponent(fileName)}`);
    return await saveFile(response, false);
};

export const useDownloadFile = (
    callback?: () => void
): UseMutationResult<void, Error, string> =>
    useMutation<void, Error, string>({
        mutationFn: downloadFile,
        onSuccess: () => callback?.(),
    });

export const useDownloadFileBlob = (
    callback?: (result: Blob) => void
): UseMutationResult<Blob, Error, string> =>
    useMutation<Blob, Error, string>({
        mutationFn: downloadFileBlob,
        onSuccess: (result) => callback?.(result),
    });
